module.exports = __webpack_public_path__ + "employee.f5398b4987aa74957103.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background/employee.png
// module id = 490
// module chunks = 5